"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INCIDENT_INVESTIGATOR_ROLLERI = exports.incidentTimelineCreateSchema = exports.incidentOrtamSchema = exports.olaySaatiSchema = exports.KILCIK_KATEGORILERI = exports.incidentArastirmaYontemiSchema = exports.incidentCauseUpdateSchema = exports.incidentCauseCreateSchema = exports.sebepKademeSchema = exports.incidentArastirmaYontemiDegeri = exports.incidentWitnessCreateSchema = exports.incidentDamageCreateSchema = exports.incidentAffectedUpdateSchema = exports.IZLENEN_ETKILENEN_ALANLARI = exports.TARAF_SINIF_MESAJI = exports.TARAF_ISTIHDAM_MESAJI = exports.KAPALI_OLAY_KAYIP_GUN_MESAJI = exports.KAPALI_OLAY_DUZENLENEBILIR_ALANLAR = exports.incidentAffectedCreateSchema = exports.incidentInjuryCreateSchema = exports.incidentKunyeBagSchema = exports.incidentOlayTuruUpdateSchema = exports.incidentRejectSchema = exports.incidentCreateSchema = exports.OLAY_YETKI_LISTE_ANAHTARLARI = exports.CALISMA_SAATI_VARSAYILAN = exports.OLAY_YETKI_VARSAYILAN = exports.olayTuretmeGirdisiSchema = exports.OLAY_TURETME_GIRDILERI = exports.incidentEkTipiSchema = exports.INCIDENT_EK_TIPLERI = exports.workHoursKaynakSchema = exports.WORK_HOURS_KAYNAKLARI = exports.incidentKanalSchema = exports.INCIDENT_KANALLARI = exports.ORAN_KPI_DISI_TARAFLAR = exports.incidentTarafSchema = exports.INCIDENT_TARAFLARI = exports.puan5x5 = exports.bes5DegerSchema = exports.YUKSELT_ONERI_SIDDET_ESIGI = exports.YUKSELT_ONERI_PUAN_ESIGI = exports.siddetSiraSchema = exports.SIDDET_MERDIVENI_MAX_SIRA = exports.SIDDET_MERDIVENI_MIN_SIRA = exports.INCIDENT_GECIS_MATRISI = exports.incidentAkisSchema = exports.INCIDENT_AKISLARI = exports.incidentDurumSchema = exports.INCIDENT_DURUMLARI = void 0;
exports.workHoursRowContractIsInSync = exports.incidentOptionsContractIsInSync = exports.incidentOlayTuruUpdateResponseContractIsInSync = exports.incidentDetailContractIsInSync = exports.incidentSummaryContractIsInSync = exports.incidentYetkilerContractIsInSync = exports.workHoursImportReportSchema = exports.workHoursImportRowResultSchema = exports.workHoursImportSonucSchema = exports.WORK_HOURS_IMPORT_SONUCLARI = exports.incidentAttachmentSchema = exports.workHoursRowSchema = exports.digerKuyrukKalemSchema = exports.digerKuyruguSatirSchema = exports.DIGER_KUYRUGU_KAYNAGI = exports.digerKuyruguKaynakSchema = exports.DIGER_KUYRUGU_KAYNAKLARI = exports.digerKuyruguListeSchema = exports.DIGER_KUYRUGU_LISTELERI = exports.publicTakipDurumSchema = exports.publicBildirimSonucSchema = exports.publicBildirimCreateSchema = exports.publicBildirimOptionsSchema = exports.incidentQrSonucSchema = exports.incidentQrUretSchema = exports.incidentSeverityConfigSchema = exports.incidentOptionsSchema = exports.incidentOlayTuruUpdateResponseSchema = exports.incidentDetailSchema = exports.incidentSummarySchema = exports.incidentYetkilerSchema = exports.workHoursUpsertSchema = exports.severityRulesUpdateSchema = exports.severityLevelUpdateSchema = exports.incidentAlanlarSchema = exports.incidentSiniflarSchema = exports.miktarBirimiSchema = exports.incidentPotansiyelSchema = exports.AKSIYON_DURUM_ETIKETI = exports.INCIDENT_ARASTIRMA_YONTEMI_ETIKETI = exports.INCIDENT_INVESTIGATOR_ROL_ETIKETI = exports.INCIDENT_KANIT_KATEGORISI_ETIKETI = exports.INCIDENT_EK_TIPI_ETIKETI = exports.SIDDET_SIRA_ETIKETI = exports.INCIDENT_TARAF_ETIKETI = exports.INCIDENT_AKIS_ETIKETI = exports.incidentKanitKategorisiSchema = exports.INCIDENT_KANIT_KATEGORILERI = exports.incidentInvestigatorCreateSchema = exports.incidentInvestigatorRolSchema = void 0;
exports.workHoursImportReportContractIsInSync = exports.incidentAttachmentContractIsInSync = exports.incidentSeverityConfigContractIsInSync = void 0;
exports.olayKapaliMi = olayKapaliMi;
exports.incidentGecisTanimi = incidentGecisTanimi;
exports.majorArastirmaMi = majorArastirmaMi;
exports.arastirmayaYukseltOnerisiMi = arastirmayaYukseltOnerisiMi;
exports.deriveGerceklesenSiddetSira = deriveGerceklesenSiddetSira;
exports.kazaDosyasiEksikMi = kazaDosyasiEksikMi;
exports.readTuretmeGirdisi = readTuretmeGirdisi;
exports.olayYetkiVarsayilani = olayYetkiVarsayilani;
exports.olayYetkiListesiIhlali = olayYetkiListesiIhlali;
exports.kapaliOlaydaDegisiklikIzinliMi = kapaliOlaydaDegisiklikIzinliMi;
exports.tarafKimlikSinifi = tarafKimlikSinifi;
exports.etkilenenDegisiklikIzleri = etkilenenDegisiklikIzleri;
exports.sebepYazilabilirMi = sebepYazilabilirMi;
exports.olayAcikMi = olayAcikMi;
exports.sgkBildirimSonTarihi = sgkBildirimSonTarihi;
exports.olayDurumEtiketi = olayDurumEtiketi;
exports.publicTakipDurumEtiketi = publicTakipDurumEtiketi;
const zod_1 = require("zod");
const shared_types_1 = require("@isg/shared-types");
const kapi_durumu_1 = require("./kapi-durumu");
/**
 * Olay (ramak kala + kaza) durum makinesi sabitleri — F3B·S1 (Kapsam §16.8 +
 * §16.8.1, ERD §10; O1-O12 · T1-T4 · R1-R13 kararları).
 *
 * PTW deseninin (ptw.ts) olay kolu: token listesi, İKİ AKIŞ ayrımı ve geçiş
 * matrisi üç katmanın paylaştığı TEK kaynaktır — @isg/db incident.ts geçiş
 * kurallarını BURADAN okur, ikinci bir tablo yazılmaz.
 */
/**
 * ÜÇ token — kapalı liste; ekran etiketleri i18n'den (enum'a Türkçe girmez).
 *
 * ✏️ T2·0 OLAY REVİZYONU (01.09.2026 — Kapsam §16.8/7-j; K2): ~~altı token~~
 * (`reported · in_review · rejected · investigating · assessing · closed`) →
 * ÜÇ. `in_review` KALKTI (inceleme araştırmadan ayrı iş değil, yapay ara
 * adımdı) · `assessing` KALKTI (akış türden türetilen eksendir; "Araştırmada"
 * iki akışın ortak işlem durumudur, etiket akıştan türer —
 * `olayDurumEtiketi`) · `closed` KALKTI — KAPANIŞ TÜRETİLİR (`olayKapaliMi`,
 * kolon yok). Prisma enum · bu liste · shared-types token birliği üçlü
 * kopyadır ve birlikte değişir (LookupListeKodu deseni).
 */
// ✏️ TUR 2½a: DÖRDÜNCÜ TOKEN `moved` — olay UYGUNSUZLUĞA taşındı (§24.1/7).
// ⚠️ SON DURUMDUR ve GEÇİŞ MATRİSİNDE ÇIKIŞI YOKTUR: taşınan kayıt yaşamaya
// devam eder (silinmez), ama üzerinde işlem yapılmaz — devamı çapraz bağın
// diğer ucundadır. Matrise "geri al" satırı EKLEME: iz kirlenir (araştırmaya
// yükseltmenin tek yönlülüğüyle aynı sınıf).
exports.INCIDENT_DURUMLARI = ['reported', 'investigating', 'rejected', 'moved'];
exports.incidentDurumSchema = zod_1.z.enum(exports.INCIDENT_DURUMLARI);
/**
 * İKİ AKIŞ (R2) — ayrışma çalışanda değil UZMANDADIR:
 * - `arastirma`: ramak kala + kaza → olay araştırması → DÖF (mecburi).
 * - `degerlendirme`: tehlikeli durum/davranış → 5x5 → DÖF veya gerekçeli
 *   aksiyonsuz kapanış.
 * Akış KOLON DEĞİLDİR — `olay_turu`ndan türetilir (olay_turu NULL = uzman
 * açtığı kaza kaydı → arastirma). Token'lar ASCII Türkçe saha kavramı
 * (süper-durum deseni).
 */
exports.INCIDENT_AKISLARI = ['arastirma', 'degerlendirme'];
exports.incidentAkisSchema = zod_1.z.enum(exports.INCIDENT_AKISLARI);
/**
 * GEÇİŞ MATRİSİ (✏️ T2·0 — 7-j.1/j.2): bildirildi → araştırmada, ya da
 * bildirildi → reddedildi. Matris dışı her (durum, işlem) FAIL-CLOSED
 * reddedilir (409). ⚠️ KAPANIŞ MATRİSTE YOKTUR — bir işlem değil, DÖF
 * satırlarından TÜRETİLİR (`olayKapaliMi`); "kapat" satırı SÖKÜLDÜ.
 * İnceleme ara adımı (`incelemeye_al`) ve değerlendirme başlatma
 * (`degerlendirmeye_al`) da SÖKÜLDÜ: akış başlatma TEK işlemdir
 * (`arastirmaya_al`), etiketi akıştan türer (*"Araştırma başlat"* /
 * *"Değerlendirme başlat"*).
 *
 * Yükselme (ramak kala → kaza) BURADA YOKTUR: durum geçişi değil, etkilenen
 * kişi listesinin ağırlaşmasıdır — kaydın kimliği değişmez (R1).
 */
exports.INCIDENT_GECIS_MATRISI = [
    // Akış başlatma — HER İKİ akışta aynı işlem (etiket akıştan türer).
    { islem: 'arastirmaya_al', eski: ['reported'], yeni: 'investigating', akis: null },
    // Red (R7): gerekçe sözlükten + serbest metin; ramak kala/kazada YALNIZ
    // mükerrer/asılsız — kural sözlüğe bağlı olduğu için @isg/db'de.
    // ✏️ T2·0 (j.2): red BİLDİRİLDİ'den — Bildirildi'nin iki çıkışı vardır.
    { islem: 'reddet', eski: ['reported'], yeni: 'rejected', akis: null },
    // ARAŞTIRMAYA YÜKSELTME (F4·B4 — gezinti kapanış turu 2): değerlendirme
    // akışındaki olay uzman kararıyla araştırma akışına yükseltilir — yüksek
    // potansiyelli olay GERÇEKLEŞMİŞ GİBİ araştırılır. Geçişten sonra akış
    // türetmesi `arastirmaya_yukseltildi_at` üzerinden 'arastirma' döner;
    // 5x5 verisi SİLİNMEZ, salt okunur tarihçe kalır (yazma yolu akış
    // kuralıyla kendiliğinden kapanır).
    // ✏️ T2·0 (K2): `assessing` kalktığı için ESKİ = YENİ = investigating —
    // `tur_duzelt` emsali: durum değişmez, AKIŞ değişir; iz log'da.
    // ⚠️ TEK YÖNLÜ (ürün sahibi kararı): GERİ İNİŞ SATIRI BİLİNÇLİ YOKTUR —
    // iz kirlenir. Matris dışı istek fail-closed 409'dur ve öyle kalmalıdır.
    //
    // ⚠️⚠️ **BU GEÇİŞİN ÜRÜN YÜZEYİ YOKTUR — YALNIZ GEÇMİŞ KAYIT HAKKIDIR**
    // (TUR 12 / K14 — ürün sahibi kararı 05.09.2026; madde 193 KAPANDI).
    // Tur 11 / R3-a olayın DEĞERLENDİRME AKIŞINI emekliye ayırdı: yeni hiçbir
    // kayıt o akışa GİREMİYOR (tehlikeli durum/davranış artık uygunsuzluk
    // kabında doğar — Kapsam §16.8/9 revizyonu). Dolayısıyla bu satır yalnız
    // **mevcut** değerlendirme akışlı kayıtlar için anlamlıdır ve dev
    // veritabanında böyle bir kayıt SIFIRDIR.
    //
    // ⚠️ **BU BİR ÖLÜ KOD DEĞİLDİR VE SÖKÜLMEZ:** Faz 5 dağıtımında eski veri
    // taşınabilir ve o kayıtların yükseltme yolu kapanmamalıdır. Satırı
    // silmek bir ÜRÜN KARARIDIR (§2.14b) — kendi kararıyla sökülmez.
    // Bu şerhin varlığı `incident-emekli-gecis.spec.ts` ile kilitlidir:
    // altı ay sonra *"çağıranı yok"* diye söken biri önce testi kırar.
    {
        islem: 'arastirmaya_yukselt',
        eski: ['investigating'],
        yeni: 'investigating',
        akis: 'degerlendirme',
    },
];
/**
 * OLAY KAPALI MI — TEK YÜKLEM (✏️ T2·0 — Kapsam §16.8/7-j.3; K1 SAF).
 *
 * Olay **kapalıdır** ⇔ DÖF ≥ 1 ∧ tümü kapalı. Başka koşul YOK: kök sebep
 * işareti kapıya BAĞLANMAZ (K1 — yerine türetilmiş kalıcı uyarı bandı +
 * rapor şerhi). Kolon YOK: ekran rozeti · liste süzgeci · rapor · SGK bandı ·
 * içerik kilidi hepsi bu fonksiyonu çağırır; ikinci bir okuyucu, bir gün
 * eklenen bir şartın diğerine sessizce eklenmemesiyle aynı arızayı geri
 * getirir (§2.40'ın türetme kolu).
 *
 * ⚠️ TAM SİMETRİ (7-j.4): değerlendirme akışında da aynı türetme — DÖF'süz
 * olay HİÇ KAPANMAZ (bilinçli ürün duruşu; değersiz bildirimin çıkışı RED).
 * ⚠️ İptal edilen DÖF (`cancelled` — 2½ şeması) sayaçtan DÜŞER: çağıran
 * `dofToplam`a iptalleri KATMAZ; bugün iptal durumu olmadığı için bu bir
 * sözleşme notudur, koşul değil.
 */
function olayKapaliMi(dofToplam, dofAcik) {
    return dofToplam >= 1 && dofAcik === 0;
}
/** (işlem, akış) → matris satırı; akış kısıtına uymayan istek `undefined`
 *  döner ve çağıran fail-closed reddeder. */
function incidentGecisTanimi(islem, akis) {
    return exports.INCIDENT_GECIS_MATRISI.find((tanim) => tanim.islem === islem && (tanim.akis === null || tanim.akis === akis));
}
/**
 * KİŞİ ŞİDDET MERDİVENİ — ÜRÜN KİLİTLİ 6 basamak (O4; müşteri değiştiremez —
 * müşteriler arası kıyasın ortak dili). Basamaklar `sira` DEĞERİYLE anılır
 * (KPI eşiği sira'ya bağlanır, kalem id'sine DEĞİL): 0 ramak kala · 1 ilk
 * yardımlı · 2 tıbbi müdahale · 3 kayıp günlü · 4 iş göremezlik / uzuv
 * kaybı · 5 ölümlü. D1 (17.08.2026, madde 58 kapanışı): 4. basamağın adı
 * "İŞ GÖREMEZLİK / UZUV KAYBI" — "sürekli" sıfatı SGK'nın hukuki statü
 * terimiyle karıştığı için düşürüldü; ad revizyonu sira eksenini ETKİLEMEZ.
 * Merdiven sözlüğü D3 metinleriyle seed'e indi (F3B·S3) — yalnız GÖSTERİM
 * katmanıdır, kayıt sira ile açılır.
 * "Kayıtlı (gün kaybı yok)" BASAMAK DEĞİL, KPI'DIR — buraya basamak ekleme.
 */
exports.SIDDET_MERDIVENI_MIN_SIRA = 0;
exports.SIDDET_MERDIVENI_MAX_SIRA = 5;
exports.siddetSiraSchema = zod_1.z
    .number()
    .int()
    .min(exports.SIDDET_MERDIVENI_MIN_SIRA)
    .max(exports.SIDDET_MERDIVENI_MAX_SIRA);
/**
 * Majör araştırma TÜRETİLMİŞ İŞARETTİR (✅ 17.08.2026 mini belge turu) —
 * KOLON/DURUM/EKRAN DEĞİL: listede süzgeç, raporda sayaç. "Aşağı çekme"
 * işlemi YOKTUR — işaret yanlışsa potansiyel şiddet düzeltilir, işaret
 * yeniden hesaplanır.
 *
 * ✏️ **F4·S2 (Y1 / madde 74): EŞİK ARTIK PARAMETREDİR.** Sabit
 * `MAJOR_ARASTIRMA_ESIGI_SIRA = 4` KALDIRILDI; yerini
 * `major_arastirma_esigi` tenant anahtarı aldı (varsayılanı yine 4 —
 * davranış değişmedi). Eşik `sira` DEĞERİNE bağlıdır, kalem id'sine değil.
 *
 * ⚠️ **Z2 — BU BİR GÖSTERİM YÜKLEMİDİR** (Kapsam §23/4): çağıran ona HER
 * ZAMAN GÜNCEL eşiği verir ve sonuç DAMGALANMAZ. Eşiğe bağlı bir KAPI
 * (geçişi reddeden kural) bugün YOKTUR ve olursa eşiği geçiş ANINDA okur,
 * orada dondurur — kapanmış kaydın kapısı yeniden çalıştırılmaz.
 */
function majorArastirmaMi(potansiyelSiddetSira, esikSira) {
    return potansiyelSiddetSira != null && potansiyelSiddetSira >= esikSira;
}
/**
 * ARAŞTIRMAYA YÜKSELTME ÖNERİSİ (F4·B4) — `majorArastirmaMi` ailesinin
 * değerlendirme-akışı üyesi: TÜRETİLMİŞ GÖSTERİM İŞARETİDİR, kapı değil.
 * Sistem yükseltmeyi ÖNERİR; karar uzmandadır — otomatik geçiş YOKTUR
 * ("sistem hesaplar ve önerir, karar sahada").
 *
 * İki kol, TEK değişken çiftinden (olasılık5 × şiddet5): 5x5 puanı en üst
 * banda düşer VEYA şiddet ekseni yüksek girilir. Değerlendirme akışında
 * "potansiyel şiddet" rolünü 5x5'in şiddet ekseni taşır (R3) — potansiyel
 * şiddet alanı o akışta hiç sorulmaz, öneri onu OKUYAMAZ.
 *
 * ⚠️ EŞİKLER ÜRÜN BAŞLANGIÇ DEĞERLERİDİR, yapılandırma yüzeyi AÇILMADI:
 * R4 ("5x5 eşik/öneri — eşik müşteride", Kapsam §16.8/15 A.4 kaydı) hâlâ
 * ürün sahibinde; anahtar açmak o kararın işidir (`major_arastirma_esigi`
 * deseni hazır bekler). 15 = klasik 5x5'in üst (kırmızı) bandının alt
 * sınırı; 4 = şiddet ekseninin "yüksek" okuması. Öneri ≠ kapı (Z6) —
 * eşiğin biraz oynak olması karar mekanizmasını bozmaz.
 */
exports.YUKSELT_ONERI_PUAN_ESIGI = 15;
exports.YUKSELT_ONERI_SIDDET_ESIGI = 4;
function arastirmayaYukseltOnerisiMi(puan5x5Degeri, siddet5) {
    return ((puan5x5Degeri != null && puan5x5Degeri >= exports.YUKSELT_ONERI_PUAN_ESIGI) ||
        (siddet5 != null && siddet5 >= exports.YUKSELT_ONERI_SIDDET_ESIGI));
}
/**
 * Gerçekleşen şiddet TÜRETİLİR (R10): etkilenen kişiler içindeki EN AĞIR
 * basamak. ELLE GİRİLEMEZ ve TARAFA BAKMAZ — imzada taraf parametresi
 * bilinçli yoktur: ziyaretçi ölümlüyse olay ölümlüdür (orandan dışlanan kişi
 * KAYDIDIR, olayın ağırlığı değil). Boş liste → null (etkilenen yok).
 */
function deriveGerceklesenSiddetSira(basamaklar) {
    if (basamaklar.length === 0)
        return null;
    return basamaklar.reduce((enAgir, sira) => Math.max(enAgir, exports.siddetSiraSchema.parse(sira)), 0);
}
/**
 * 5x5 — ✏️ **EVİ DEĞİŞTİ (05.09.2026, tur 11 / R3-c): `./nonconformity`.**
 * Olayın değerlendirme akışı emekliye ayrıldı (§16.8/9 revizyonu); araç,
 * içeriğin taşındığı kaba gitti. **BURADA YENİDEN TANIMLANMAZ** — yeniden
 * ihraç edilir, çünkü olay tarafında hâlâ **salt okunur tarihçe** olarak
 * okunur (mevcut kayıtların puanı ekranda görünmeye devam eder) ve
 * `arastirmayaYukseltOnerisiMi` onu girdi alır.
 *
 * ⚠️ **YAZMA YOLU OLAYDA YOKTUR:** `setIncident5x5` servisi ve
 * `POST incidents/:id/bes5` ucu **söküldü**; yeni kayıt bu akışa zaten
 * giremiyor (taşıma kapısı daraldı — `bildirimKabiCoz` + `moveNonconformity`).
 */
var nonconformity_1 = require("./nonconformity");
Object.defineProperty(exports, "bes5DegerSchema", { enumerable: true, get: function () { return nonconformity_1.bes5DegerSchema; } });
Object.defineProperty(exports, "puan5x5", { enumerable: true, get: function () { return nonconformity_1.puan5x5; } });
/**
 * Etkilenen kişi TARAF ekseni (R10 — dört kalem). Firma bilgisi KOLON DEĞİL:
 * ana firma tarafında İSTİHDAMDAN, yüklenici tarafında YÜKLENİCİ KAYDINDAN
 * okunur. Ziyaretçi/üçüncü şahısta kişi kaydı yok — ad + iletişim kayıtta
 * (KVKK asgari; kimlik no gerekmez).
 */
exports.INCIDENT_TARAFLARI = [
    'employee',
    'contractor_worker',
    'visitor',
    'third_party',
];
exports.incidentTarafSchema = zod_1.z.enum(exports.INCIDENT_TARAFLARI);
/**
 * ORAN KPI DIŞLAMASI (R10) — KOLON DEĞİL, RAPOR KURALI SABİTİ: ziyaretçi ve
 * üçüncü şahsın çalışma saati yoktur, PAYDAYA girmezler (dışlanmazsa oran
 * sessizce şişer). Olay SAYISINA ve şiddet dağılımına GİRERLER — bu sabit
 * yalnız oran KPI'larının pay tarafını süzer. Hesaplanmış oran HİÇBİR YERDE
 * SAKLANMAZ (R12): çarpan rapor parametresidir, bu pakete oran/çarpan sabiti
 * EKLENMEZ.
 */
exports.ORAN_KPI_DISI_TARAFLAR = ['visitor', 'third_party'];
/** Bildirim kanalı (Kapsam §5.5/§7 — çift kanal). Uzman kaza kaydında null. */
exports.INCIDENT_KANALLARI = ['sso_app', 'qr'];
exports.incidentKanalSchema = zod_1.z.enum(exports.INCIDENT_KANALLARI);
/** Çalışma saati kaynağı (R11): elle giriş ve import AYNI tabloya yazar. */
/** TUR 6 / K8: `temsilci` — kişi dosyasısız, hesaba bağlı satır (§18.2/1 revizyon izi). */
exports.WORK_HOURS_KAYNAKLARI = ['elle', 'import', 'temsilci'];
exports.workHoursKaynakSchema = zod_1.z.enum(exports.WORK_HOURS_KAYNAKLARI);
/**
 * Kaza dosyası ek tipi (R13 — F3B·S5): DAR enum, serbest metin tip alanı
 * YOK (enum dışı 422). Sağlık tipli içerik bu listeye GİRMEZ — kanaat
 * yazısı istisnası yalnız yüklenici evrakındadır (Teknoloji §4.11.1).
 */
exports.INCIDENT_EK_TIPLERI = ['sgk_bildirimi', 'fotograf', 'tutanak', 'diger'];
exports.incidentEkTipiSchema = zod_1.z.enum(exports.INCIDENT_EK_TIPLERI);
/**
 * "Dosya eksik" TÜRETİLMİŞ İŞARETTİR (R13 — F3B·S5; `majorArastirmaMi`
 * deseni, KOLON DEĞİL): kaza kaydında (`olay_turu` NULL) canlı
 * `sgk_bildirimi` eki yoksa doğar. TEK yüklem: liste işareti · detay uyarı
 * bandı · kapanış uyarısı hepsi bunu çağırır — dağınık koşul yazılmaz
 * (olayAnonimMi ilkesi).
 *
 * ✏️ REVİZYON İZİ — ÜÇ ADIM (Kapsam §16.8/13):
 *   1. 16.08.2026 (R13): "kalıcı uyarı — kapanıştan sonra da kaybolmaz".
 *   2. 18.08.2026 (F3B·S5): işaret AÇIK kayda daraltıldı (`durum !==
 *      'closed'` koşulu buradaydı).
 *   3. 18.08.2026 (F3B·S6, ürün sahibi kararı): daralma GERİ ALINDI —
 *      **durum koşulu DÜŞTÜ**, işaret kapanmış kayıtta da görünür.
 * Gerekçe: işaret kovalamaz ve kapanışı engellemez (R13 aynen) — GÖRÜNÜR
 * kılar; kapanmış kazanın eksik SGK belgesi görünmez olsaydı "belge
 * sonradan da yüklenebilir" sözünün takibi kalmazdı. Bu yüzden imza artık
 * DURUM ALMAZ: parametre dursaydı, yükleme bakan bir sonraki kişi "demek
 * ki bir yerde duruma bakılıyor" diye okurdu.
 */
function kazaDosyasiEksikMi(olayTuruRefId, canliSgkEkiVar) {
    return olayTuruRefId == null && !canliSgkEkiVar;
}
/**
 * Seviye türetme girdisi (O7 + D4, 17.08.2026 — F3B·S3): olay sınıfı
 * kaleminin kuralındaki MAKİNE-OKUR `turetme_girdisi` anahtarının kapalı
 * değer kümesi. Müşteri sınıf kalemi ana kaleme bağlanır ve girdiyi MİRAS
 * alır; anahtarsız kalem ("Diğer" dahil) türetmeye KATILMAZ. Girdi tipi
 * incident_severity_rule satırında TUTULMAZ — tek kaynak bu anahtardır.
 *   merdiven      gerçekleşen şiddet `sira` (kişi güvenliği · trafik)
 *   yayilim       yayılım sınırı kaleminin `sira`sı (çevre)
 *   hasar_tutari  türetilen hasar toplamı ≥ eşik (maddi hasar / varlık)
 *   esik_tablosu  kayıp miktarı ≥ eşik × madde sınıfı (proses güvenliği)
 */
exports.OLAY_TURETME_GIRDILERI = [
    'merdiven',
    'yayilim',
    'hasar_tutari',
    'esik_tablosu',
];
exports.olayTuretmeGirdisiSchema = zod_1.z.enum(exports.OLAY_TURETME_GIRDILERI);
/**
 * Sınıf kaleminin kurallar jsonb'sinden türetme girdisini okur — bozuk/eksik
 * değer null döner (kalem türetmeye katılmaz; readUyariEsigiGun deseni:
 * bozuk kural sistemi düşürmez).
 */
function readTuretmeGirdisi(kurallar) {
    if (typeof kurallar !== 'object' || kurallar === null)
        return null;
    const aday = kurallar['turetme_girdisi'];
    const parsed = exports.olayTuretmeGirdisiSchema.safeParse(aday);
    return parsed.success ? parsed.data : null;
}
// ─────────────────────────────────────────────────────────────────────────────
// F3B·S2 — UÇ→ŞAPKA VE ANONİMLİK (U1-U12; Kapsam §16.8/14 + §20.5).
// İLKE (U6): "KİM yapar → YAPILANDIRILABİLİR. NE OLUR → SABİT." Aşağıdaki
// sabitler KİM tarafının varsayılanlarıdır; NE tarafı (durum makinesi,
// kapanış kapıları, türetmeler, anonimlik kuralları) yukarıda ve @isg/db'de
// sabittir — tenant listesi onlara dokunamaz.
// ─────────────────────────────────────────────────────────────────────────────
/**
 * U7 — varsayılan olay yetki listesi: uzman + TEKNİSYEN + şirket yön. +
 * lokasyon yön. (hepsi bahçe denetimli). `area_supervisor` BİLİNÇLİ DIŞARIDA:
 * kendi sahasındaki tehlikeli davranış bildirimini reddedebilen kişi o
 * davranışın sorumlusunun amiri olurdu — yapısal çıkar çatışması (tenant
 * isterse listeye ekler — KİM yapılandırılabilir). Teknisyen RED dahil
 * uzmanla EŞİTTİR — yetki farkının ilk somutlaşması, sonraki modüllere EMSAL.
 */
exports.OLAY_YETKI_VARSAYILAN = [
    'isg_specialist',
    'isg_technician',
    'company_admin',
    'location_manager',
];
/** U9 — çalışma saati varsayılanı: U7 + temsilci (yalnız kendi firması —
 *  firma sınırı listeyle değil oturum/bahçe kapısıyla çizilir). */
exports.CALISMA_SAATI_VARSAYILAN = [
    ...exports.OLAY_YETKI_VARSAYILAN,
    'contractor_rep',
];
/**
 * U6 — tenant liste anahtarları (PTW geri_cekme/saha_kontrol deseninin
 * genellenmesi; yerleşim `tenant_setting`, yeni tablo YOK):
 * - `olay_inceleme`      : akış başlatma · red · tür düzeltme · araştırma
 *                          yazmaları (red AYRI anahtar DEĞİL — a1)
 * - `calisma_saati_giris`: work_hours upsert
 * ✏️ T2·0 (K9): ~~`olay_kapanis`~~ KALKTI — kapanış bir işlem değil,
 * türetmedir (7-j.3); "kim kapatır" sorusu yok. Yetim satırlar migration'da
 * silindi.
 */
exports.OLAY_YETKI_LISTE_ANAHTARLARI = ['olay_inceleme', 'calisma_saati_giris'];
function olayYetkiVarsayilani(anahtar) {
    return anahtar === 'calisma_saati_giris' ? exports.CALISMA_SAATI_VARSAYILAN : exports.OLAY_YETKI_VARSAYILAN;
}
/**
 * TABAN KİLİTLER (U6) — hiçbir tenant listesi aşamaz; yazma kapısı bu
 * yüklemi çağırır ve ihlalde 422 döner:
 * - `viewer` hiçbir yazma listesine giremez (salt-okunur genel kural),
 * - `contractor_rep` YALNIZ `calisma_saati_giris`e eklenebilir — olay
 *   inceleme listesine hiçbir yapılandırmayla giremez (KPI'ı
 *   düzeltme yetkisi tenant sınırı dışına çıkamaz).
 * Dönen değer ihlal mesajıdır; null = liste geçerli.
 */
function olayYetkiListesiIhlali(anahtar, liste) {
    for (const sapka of liste) {
        if (!shared_types_1.ROLE_TYPES.includes(sapka)) {
            return `Tanınmayan şapka: ${sapka}`;
        }
        if (sapka === 'viewer') {
            return 'İzleyici hiçbir yazma listesine eklenemez (salt-okunur genel kural)';
        }
        if (sapka === 'contractor_rep' && anahtar !== 'calisma_saati_giris') {
            return ('Yüklenici temsilcisi yalnız çalışma saati girişine eklenebilir — ' +
                'olay inceleme listesine hiçbir yapılandırmayla giremez');
        }
    }
    return null;
}
// ── API sözleşmeleri (F3B·S2 uçları — ptw.ts deseni) ─────────────────────────
/**
 * Kapı 1 — oturumlu bildirim + uzmanın kaza kaydı (U5). `olayTuruRefId`
 * null = KAZA (O10 — kaza bildirimin ekseni değildir; açma yetkisi
 * `olay_inceleme` çözümlemesinden).
 *
 * `anonim` alanı ARTIK KABUL EDİLMEZ (✏️ madde 64, 17.08.2026 — U5
 * revizyonu: girişliyken anonim bildirim yoktur; anonim bildirim TEK KAPI,
 * QR kanalı). Alan şemada BİLİNÇLİ durur: şemadan silinseydi `anonim: true`
 * gönderen eski istemcinin alanı sessizce DÜŞER ve kayıt KİMLİKLİ açılırdı
 * — anonimlik beklentisini sessizce kırmak en pahalı hata olurdu. Uç bu
 * alanı görünce 422 döner (D2 dili: anonim bildirim QR kanalından).
 */
exports.incidentCreateSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid(),
    locationNodeId: zod_1.z.uuid().nullish(),
    olayTuruRefId: zod_1.z.uuid().nullable(),
    olayTarihi: zod_1.z.iso.datetime(),
    anlati: zod_1.z.string().min(1),
    anonim: zod_1.z.boolean().optional(),
});
exports.incidentRejectSchema = zod_1.z.object({
    gerekceRefId: zod_1.z.uuid(),
    gerekceMetin: zod_1.z.string().min(1),
    mukerrerHedefIncidentId: zod_1.z.uuid().nullish(),
});
/**
 * U2 — tür düzeltme (KİMLİKLİ kayıt; kural serviste). ✏️ T2·0 (K8): HER
 * açık durumda (reported + investigating) yapılabilir; TEK YASAK akışı
 * DÜŞÜREN değişim (araştırma-akışlı türden değerlendirme-akışlı türe → 422).
 * Yanıt detay + ENGELLEMEYEN uyarılar taşır (aynı-akış değişiminde
 * *"içerik korunur, uyumu kontrol edin"*).
 */
exports.incidentOlayTuruUpdateSchema = zod_1.z.object({ olayTuruRefId: zod_1.z.uuid() });
/**
 * KÜNYE BAĞLARI (F4·B3 — A1): lokasyon + iş ekipmanı; undefined = dokunma,
 * null = temizle (incidentOrtam deseni). Lokasyon kolonu olay çekirdeğinden
 * beri vardı — eksik olan EKRANDAKİ KAPIYDI; ekipman bağının değeri
 * İSTATİSTİKTİR ("bu ekipman kaç olayda"). İkisi de zorunlu değil (O6).
 */
exports.incidentKunyeBagSchema = zod_1.z.object({
    locationNodeId: zod_1.z.uuid().nullish(),
    equipmentId: zod_1.z.uuid().nullish(),
});
/**
 * YARALANMA SATIRI (F4·B3 — A2): etkilenen kişiye ÇOKLU; tür × bölge
 * SÖZLÜKTEN. "Diğer" kaleminde serbest metin zorunluluğu SERVİSTE (§19/13 —
 * cevap sözlük satırında). ⚠️ OLAY VERİSİDİR, TANI DEĞİL (§2.3).
 */
exports.incidentInjuryCreateSchema = zod_1.z.object({
    affectedPersonId: zod_1.z.uuid(),
    yaralanmaTuruRefId: zod_1.z.uuid(),
    vucutBolgesiRefId: zod_1.z.uuid(),
    serbestMetin: zod_1.z.string().nullish(),
});
exports.incidentAffectedCreateSchema = zod_1.z.object({
    taraf: exports.incidentTarafSchema,
    personId: zod_1.z.uuid().nullish(),
    siddetBasamagi: exports.siddetSiraSchema,
    kayipGun: zod_1.z.number().int().min(0).nullish(),
    tedaviNotu: zod_1.z.string().nullish(),
    ad: zod_1.z.string().nullish(),
    iletisim: zod_1.z.string().nullish(),
});
/**
 * Etkilenen kişi satırı GÜNCELLEME gövdesi (madde 309-e, 08.10.2026): basamak ·
 * kayıp gün · tedavi notu. ⚠️ Ölümlüye geçişte `kayipGun` gönderilmez — servis
 * mevcut değeri aynı işlemde NULL yapar; ölümlü hedefe dolu `kayipGun` 422.
 */
/**
 * KAPANMIŞ OLAYDA YALNIZ KAYIP GÜN DÜZENLENİR (08.10.2026 — Kapsam §16.8/13 ✏️
 * · §14 KG-3). Kapanmış olayın içerik kilidinin TEK istisnası: sonradan gelen
 * rapor/SGK günü. Basamak · kişi · taraf · tedavi notu 409 (`IncidentKilitliError`
 * — kayıt durumu ekseni). Servis ve ekran kapısı AYNI yüklemi okur.
 */
exports.KAPALI_OLAY_DUZENLENEBILIR_ALANLAR = ['kayipGun'];
exports.KAPALI_OLAY_KAYIP_GUN_MESAJI = 'Bu olay kapalı — yalnız kayıp gün düzenlenebilir; basamak, kişi ve öteki alanlar salt okunur.';
function kapaliOlaydaDegisiklikIzinliMi(degisiklik) {
    const dokunulan = Object.entries(degisiklik)
        .filter(([, deger]) => deger !== undefined)
        .map(([alan]) => alan);
    return (dokunulan.length > 0 &&
        dokunulan.every((alan) => exports.KAPALI_OLAY_DUZENLENEBILIR_ALANLAR.includes(alan)));
}
/**
 * TARAFIN KİMLİK SINIFI (madde 310): kişi kayıtlı taraflar (çalışan ·
 * yüklenici işçisi — `person_id`) ve kişisiz taraflar (ziyaretçi · üçüncü şahıs
 * — `ad`). Taraf yalnız AYNI sınıf içinde düzenlenir; sınıf değişimi kimliği
 * değiştirir → satır kaldırılıp yeniden açılır (422).
 */
function tarafKimlikSinifi(taraf) {
    return taraf === 'employee' || taraf === 'contractor_worker' ? 'kisi' : 'kisisiz';
}
/**
 * MADDE 310-b (08.10.2026): TARAF, KİŞİNİN OLAY GÜNÜNDEKİ İSTİHDAMIYLA UYUŞMALI —
 * `employee` için olay gününde geçerli ŞİRKET istihdamı (`contractor_id` NULL),
 * `contractor_worker` için geçerli YÜKLENİCİ bağı (`contractor_id` dolu).
 * Ekleme ve güncelleme ucunda; uyuşmazlık 422 (`@isg/db assertTarafIstihdami`).
 */
exports.TARAF_ISTIHDAM_MESAJI = {
    employee: 'Çalışan tarafı için kişinin olay tarihinde geçerli bir istihdamı (şirket) olmalı — kişi o gün çalışan değilse taraf yüklenici işçisi ya da üçüncü şahıs olabilir.',
    contractor_worker: 'Yüklenici işçisi tarafı için kişinin olay tarihinde geçerli bir yüklenici bağı olmalı — kişi o gün yüklenici işçisi değilse taraf çalışan ya da üçüncü şahıs olabilir.',
};
exports.TARAF_SINIF_MESAJI = 'Taraf yalnız aynı kimlik sınıfı içinde değiştirilebilir (çalışan ↔ yüklenici işçisi · ziyaretçi ↔ üçüncü şahıs); kişi kaydı değişiyorsa satırı kaldırıp yeniden ekleyin.';
/**
 * İZLENEN ALANLAR (madde 310 — ERD v1.04): etkilenen satırında bu üç alanın her
 * değişimi `incident_affected_person_change_log`a yazılır — açık ve kapanmış
 * olayda. Ad · iletişim · tedavi notu İZLENMEZ (KVKK). Değer biçimi TEXT: sayı
 * ondalık dizge, taraf enum token'ı. Tek üretici `etkilenenDegisiklikIzleri`.
 */
exports.IZLENEN_ETKILENEN_ALANLARI = ['siddet_basamagi', 'kayip_gun', 'taraf'];
function etkilenenDegisiklikIzleri(onceki, sonraki) {
    const izler = [];
    if (onceki.siddetBasamagi !== sonraki.siddetBasamagi) {
        izler.push({
            alan: 'siddet_basamagi',
            eskiDeger: String(onceki.siddetBasamagi),
            yeniDeger: String(sonraki.siddetBasamagi),
        });
    }
    if (onceki.kayipGun !== sonraki.kayipGun) {
        izler.push({
            alan: 'kayip_gun',
            eskiDeger: onceki.kayipGun === null ? null : String(onceki.kayipGun),
            yeniDeger: sonraki.kayipGun === null ? null : String(sonraki.kayipGun),
        });
    }
    if (onceki.taraf !== sonraki.taraf) {
        izler.push({ alan: 'taraf', eskiDeger: onceki.taraf, yeniDeger: sonraki.taraf });
    }
    return izler;
}
exports.incidentAffectedUpdateSchema = zod_1.z
    .object({
    siddetBasamagi: exports.siddetSiraSchema.optional(),
    kayipGun: zod_1.z.number().int().min(0).nullable().optional(),
    tedaviNotu: zod_1.z.string().nullable().optional(),
    /** Madde 310: taraf yalnız aynı kimlik sınıfı içinde (serviste 422). */
    taraf: exports.incidentTarafSchema.optional(),
})
    .refine((g) => Object.values(g).some((v) => v !== undefined), {
    message: 'Güncellenecek alan yok',
});
exports.incidentDamageCreateSchema = zod_1.z.object({
    kalem: zod_1.z.string().min(1),
    tutar: zod_1.z.number().min(0).nullish(),
});
exports.incidentWitnessCreateSchema = zod_1.z.object({
    personId: zod_1.z.uuid().nullish(),
    ad: zod_1.z.string().nullish(),
    ifade: zod_1.z.string().min(1),
});
/**
 * SEBEP AĞACI DÜĞÜMÜ (F4·B1 — O1). Üç yöntem AYNI gövdeyi doldurur:
 * *5 Neden* `ustSebepId` + `metin` ile derin zincir · *balık kılçığı* aynı
 * köke çok sayıda alt düğüm · *sebep tablosu* `sebepRefId` ile sözlükten.
 *
 * ⚠️ `sebepRefId` NULL olabilir (serbest metin düğümü) ama İŞARETLİ düğümde
 * ZORUNLUDUR — kural SERVİSTE ve DB CHECK'te (ERD §12/39-iii): rapor işaretli
 * KALEMLERİ sayar, sayılamayan bir kök sebep sessizce eksik tablo üretir.
 */
/**
 * ARAŞTIRMA YÖNTEMİ (O2). Üç değer; DÖRDÜNCÜSÜ (neden ağacı · bariyer
 * analizi) buraya bir satırdır — veri yapısı değişmez (O1).
 * ⚠️ IP SINIRI: ticari taksonomiler (TapRooT · ICAM) ürünle DAĞITILMAZ.
 */
exports.incidentArastirmaYontemiDegeri = zod_1.z.enum(['five_whys', 'fishbone', 'cause_table']);
/** Sebep ağacı kademesi — 1 doğrudan / 2 sistemsel (taksonomi iki katmanlı). */
exports.sebepKademeSchema = zod_1.z.union([zod_1.z.literal(1), zod_1.z.literal(2)]);
exports.incidentCauseCreateSchema = zod_1.z.object({
    sebepRefId: zod_1.z.uuid().nullish(),
    kokSebepMi: zod_1.z.boolean(),
    serbestMetin: zod_1.z.string().nullish(),
    ustSebepId: zod_1.z.uuid().nullish(),
    metin: zod_1.z.string().nullish(),
    kademe: exports.sebepKademeSchema.nullish(),
});
/** Düğüm güncelleme — `undefined` = dokunma (alan-alan ayrım servise taşınır). */
exports.incidentCauseUpdateSchema = zod_1.z.object({
    kokSebepMi: zod_1.z.boolean().optional(),
    serbestMetin: zod_1.z.string().nullish(),
    ustSebepId: zod_1.z.uuid().nullish(),
    metin: zod_1.z.string().nullish(),
    kademe: exports.sebepKademeSchema.nullish(),
});
exports.incidentArastirmaYontemiSchema = zod_1.z.object({
    yontem: exports.incidentArastirmaYontemiDegeri.nullable(),
});
/**
 * SEBEP AĞACI YAZILABİLİR Mİ — TEK YÜKLEM (F4·B2 · §2.40).
 *
 * ⚠️ **Bu fonksiyonun varlık sebebi bir arıza sınıfıdır.** Ekran, araştırma
 * bölümünü yalnız *"inceleme yetkim var + kayıt kapalı değil"* koşuluyla
 * çiziyordu; sunucu ise `investigating` istiyordu. Sonuç: **kullanıcıya
 * sunulmuş ama işlemeyen bir kontrol** — basılıyor, iç dilde hata veriyor
 * (*"'sebep_isaretle' işlemi 'reported' durumunda tanımlı değil"*).
 *
 * Yüklem burada durur ki **`assertSebepYazilabilir` (kapı) ile
 * `yetkiler.sebepYazabilir` (görünürlük) AYNI cümleyi okusun.** İkisi ayrı
 * yazılsaydı, birine eklenen bir koşul diğerine sessizce eklenmez ve arıza
 * bir sonraki turda aynı biçimde geri gelirdi.
 *
 * Üç koşul da AYNI kaynaktan: araştırma akışı (R2 — kök sebep analizi
 * değerlendirme akışına ait değildir) · `investigating` (kök sebep
 * ARAŞTIRMANIN SONUCUDUR) · açık kayıt (`olayAcikMi` — red ya da TÜRETİLMİŞ
 * kapanış içerik kilididir; ✏️ T2·0 K6: kapalı olayda sebep DÜZENLEME
 * kilitli, sebep satırından DÖF açmak AÇIK — o yüklem bu değil).
 */
function sebepYazilabilirMi(akis, durum, kapali) {
    if (!olayAcikMi(durum, kapali))
        return false;
    return akis === 'arastirma' && durum === 'investigating';
}
/**
 * BALIK KILÇIĞININ KILÇIKLARI (O1 — *yöntem bir ARAÇTIR*, bir kural değil).
 *
 * Klasik 6M omurgası. ⚠️ **BU BİR SÖZLÜK DEĞİLDİR ve sözlüğe İNMEZ:**
 * kök sebep taksonomisi (25 kategori) *neyin sebep olduğunu* söyler, kılçık
 * kategorileri ise *kağıdın nasıl bölündüğünü*. Müşteri taksonomiyi
 * genişletir (O5); yöntemin omurgasını genişletmez — genişletirse balık
 * kılçığı balık kılçığı olmaktan çıkar.
 *
 * Kılçık kökleri ağaca **serbest metin düğümü** olarak (kalem referansı
 * YOK) yazılır; bu yüzden **işaretlenemezler** — kök sebep işareti kalem
 * ister (ERD §12/39-iii). Doğrusu da budur: *"İnsan"* bir kök sebep değil,
 * bir başlıktır.
 */
exports.KILCIK_KATEGORILERI = [
    'İnsan',
    'Makine / ekipman',
    'Yöntem',
    'Malzeme',
    'Ortam',
    'Ölçüm / kontrol',
];
// ─────────────────────────────────────────────────────────────────────────────
// F4·B2·2 — ARAŞTIRMA ALANLARI (madde 146) + SGK ÜÇ İŞ GÜNÜ SAYACI (madde 30)
// ─────────────────────────────────────────────────────────────────────────────
/**
 * OLAY KAYDI AÇIK MI — TEK YÜKLEM (§2.40'ın ikinci uygulaması; `sebepYazilabilirMi`
 * kardeşi). Servisteki `assertIncidentMutable` kapısı ile detay yanıtının
 * `yetkiler.arastirmaKaydiYazabilir` bayrağı AYNI cümleyi okur — ikisi ayrı
 * yazılsaydı ortam/kronoloji/ekip bölümleri de "açık görünüp reddeden"
 * sınıfına düşerdi. Terminal hâller: `rejected` · TÜRETİLMİŞ kapalı (✏️ T2·0
 * — `closed` token'ı kalktı; ikinci parametre `olayKapaliMi`nin sonucudur.
 * K6: kapalı olayda içerik salt okunur, yeni DÖF kilidi kaldırır).
 */
function olayAcikMi(durum, kapali) {
    return durum !== 'rejected' && !kapali;
}
/** Ortam güncelleme (undefined = dokunma, null = temizle — incidentAlanlar
 *  deseni). HİÇBİRİ ZORUNLU DEĞİL (O6). Saat DUVAR SAATİ metnidir ("HH:MM") —
 *  Timestamptz olsaydı G11'in saat dilimi tuzağına girerdi. */
exports.olaySaatiSchema = zod_1.z
    .string()
    .regex(/^([01][0-9]|2[0-3]):[0-5][0-9]$/, 'Saat "SS:DD" biçiminde olmalı (ör. 14:30)');
exports.incidentOrtamSchema = zod_1.z.object({
    olaySaati: exports.olaySaatiSchema.nullish(),
    havaDurumu: zod_1.z.string().nullish(),
    aydinlatmaRefId: zod_1.z.uuid().nullish(),
    zeminRefId: zod_1.z.uuid().nullish(),
    vardiya: zod_1.z.string().nullish(),
});
/** Kronoloji satırı (A2 — TEK TAŞIYICI: "öncesi/anı/sonrası" ayrı metin
 *  alanları AÇILMADI; evreyi zaman çizelgesi söyler). `zaman` nullable —
 *  saati bilinmeyen adım da yazılır; sıra numarasını SERVİS atar. */
exports.incidentTimelineCreateSchema = zod_1.z.object({
    zaman: zod_1.z.iso.datetime().nullish(),
    metin: zod_1.z.string().min(1),
});
/** Araştırma ekibi rolü — yöneten / üye. ⚠️ EKİP ÜYELİĞİ YETKİ VERMEZ
 *  (risk ekibi R6 emsali; kaynak taraması incident-access spec'inde). */
exports.INCIDENT_INVESTIGATOR_ROLLERI = ['yoneten', 'uye'];
exports.incidentInvestigatorRolSchema = zod_1.z.enum(exports.INCIDENT_INVESTIGATOR_ROLLERI);
exports.incidentInvestigatorCreateSchema = zod_1.z.object({
    personId: zod_1.z.uuid(),
    rol: exports.incidentInvestigatorRolSchema,
});
/** Kanıt KATEGORİSİ (sektörde ortak dörtlü) — ek TİPİNDEN ayrı eksen:
 *  tip dosyanın NE olduğunu, kategori kanıtın NEYİ gösterdiğini söyler.
 *  Nullable — mevcut ekler kategorisiz yaşar (O6). */
exports.INCIDENT_KANIT_KATEGORILERI = ['dokuman', 'insan', 'parca', 'pozisyon'];
exports.incidentKanitKategorisiSchema = zod_1.z.enum(exports.INCIDENT_KANIT_KATEGORILERI);
/**
 * SGK BİLDİRİMİNİN SON GÜNÜ — olay tarihi + ÜÇ İŞ GÜNÜ (madde 30 /
 * yükümlülük #30). "İş günü" = hafta sonu HARİÇ.
 *
 * ⚠️ ŞERH — RESMÎ TATİL TAKVİMİ ÜRÜNE GİRMEZ: resmî tatiller hesaba
 * KATILMAZ; müşteri vadeyi kendi takvimine göre yorumlar. Uydurma bir tatil
 * takvimi kurmak, yanlış günü "kesin vade" diye göstermek olurdu — eksik
 * bilgiyi açıkça söylemek, yanlış bilgiyi kesin göstermekten iyidir
 * (eşik/periyot uydurma kuralının takvim kolu).
 *
 * Girdi ISO damgasının GÜN parçası okunur (G11 — gün hassasiyetli alan
 * yerel saate çevrilmez); çıktı ISO gün ("YYYY-MM-DD").
 */
function sgkBildirimSonTarihi(olayTarihiIso) {
    const gun = new Date(`${olayTarihiIso.slice(0, 10)}T00:00:00Z`);
    let kalanIsGunu = 3;
    while (kalanIsGunu > 0) {
        gun.setUTCDate(gun.getUTCDate() + 1);
        const haftaGunu = gun.getUTCDay();
        if (haftaGunu !== 0 && haftaGunu !== 6)
            kalanIsGunu -= 1;
    }
    return gun.toISOString().slice(0, 10);
}
// ── Paylaşılan etiketler (S9 kuralı — ekran ile SUNUCUDA üretilen rapor
// aynı kelimeyi kullansın; RISK_SEVIYESI_ETIKETI emsali). Web tr.ts bu
// haritaları YENİDEN YAZMAZ, buradan alır. ─────────────────────────────────
/**
 * DURUM ETİKETİ — FONKSİYON (✏️ T2·0 K2; eski `Record` kalktı): `investigating`
 * akışa göre *Araştırmada* / *Değerlendirmede* okunur, TÜRETİLMİŞ kapalı
 * *Kapandı* der (ekran bugünkü kelimeleri korur; token'lar değişti). Rapor
 * ile ekran aynı kelimeyi buradan alır (S9 kuralı).
 */
function olayDurumEtiketi(durum, akis, kapali) {
    if (durum === 'rejected')
        return 'Reddedildi';
    if (kapali)
        return 'Kapandı';
    if (durum === 'reported')
        return 'Bildirildi';
    return akis === 'arastirma' ? 'Araştırmada' : 'Değerlendirmede';
}
/**
 * PUBLIC TAKİP ETİKETİ (K11 — D2): anonim takip yanıtına AKIŞ eklenmez
 * (araştırma/değerlendirme ayrımı içerik sızdırır); kapalı kayıt *Sonuçlandı*
 * (nötr — "kapandı/DÖF" mekanizması dışarı anlatılmaz). Reddedilen kayıt
 * bugüne kadar olduğu gibi *Reddedildi* der (takip numarasının sahibi
 * bildirenin kendisidir).
 */
function publicTakipDurumEtiketi(durum, kapali) {
    if (durum === 'rejected')
        return 'Reddedildi';
    if (kapali)
        return 'Sonuçlandı';
    return durum === 'reported' ? 'Bildirildi' : 'İşlemde';
}
/** F4·B3 — rapor künyesine akış girdi (C1); tr.ts alias'lar (S9 kuralı). */
exports.INCIDENT_AKIS_ETIKETI = {
    arastirma: 'Araştırma',
    degerlendirme: 'Değerlendirme',
};
exports.INCIDENT_TARAF_ETIKETI = {
    employee: 'Çalışan',
    contractor_worker: 'Yüklenici çalışanı',
    visitor: 'Ziyaretçi',
    third_party: 'Üçüncü şahıs',
};
/** D1 (madde 58): 4. basamak "İş göremezlik / uzuv kaybı" — "sürekli" yok. */
exports.SIDDET_SIRA_ETIKETI = {
    0: 'Ramak kala',
    1: 'İlk yardımlı',
    2: 'Tıbbi müdahale',
    3: 'Kayıp günlü',
    4: 'İş göremezlik / uzuv kaybı',
    5: 'Ölümlü',
};
exports.INCIDENT_EK_TIPI_ETIKETI = {
    sgk_bildirimi: 'SGK bildirimi',
    fotograf: 'Fotoğraf',
    tutanak: 'Tutanak',
    diger: 'Diğer',
};
exports.INCIDENT_KANIT_KATEGORISI_ETIKETI = {
    dokuman: 'Doküman',
    insan: 'İnsan',
    parca: 'Parça',
    pozisyon: 'Pozisyon',
};
exports.INCIDENT_INVESTIGATOR_ROL_ETIKETI = {
    yoneten: 'Araştırmayı yöneten',
    uye: 'Ekip üyesi',
};
exports.INCIDENT_ARASTIRMA_YONTEMI_ETIKETI = {
    five_whys: '5 Neden',
    fishbone: 'Balık kılçığı',
    cause_table: 'Sebep tablosu',
};
/**
 * Aksiyon yaşam döngüsü etiketleri — raporun DÖF listesi ile ekran aynı
 * kelimeyi kullansın diye buraya alındı (tr.ts buradan alias'lar).
 *
 * ⚠️ **BU HARİTA TEKTİR.** T2 tur 2'de `index.ts`e ikinci bir kopya yazıldı
 * ve *"Tamamlandı — onay bekliyor"* sessizce *"Tamamlandı bildirildi"*e
 * döndü; iki e2e yakaladı. İkinci bir aksiyon durum etiketi haritası açma.
 *
 * ✏️ Tip `Record<string, string>`ten TOKEN KÜMESİNE daraltıldı (T5): süzgeç
 * açılır listesi etiketleri tek tek okuyor ve `Record<string, …>` altında
 * her okuma `undefined` geliyordu. Küme kapalı olduğuna göre haritanın da
 * kapalı olması gerekir — yeni bir durum eklenirse etiketi yazmak ZORUNLU
 * olur (derleme hatası), sessiz boşluk doğmaz.
 */
exports.AKSIYON_DURUM_ETIKETI = {
    open: 'Açık',
    completed_reported: 'Tamamlandı — onay bekliyor',
    closed: 'Kapalı',
    // ✏️ Tur 2½b (V3): İPTAL bir kapanış DEĞİLDİR ve etiketi de öyle
    // demez — "Kapalı" ile karışırsa raporda iki farklı gerçek tek kelimeye
    // iner (kapanma oranı iptalleri de sayardı).
    cancelled: 'İptal edildi',
};
exports.incidentPotansiyelSchema = zod_1.z.object({ sira: exports.siddetSiraSchema });
// ✏️ `incidentBes5Schema` SÖKÜLDÜ (tur 11 / R3-a): olayda 5x5 yazma yolu
// yoktur. Gövde şeması uygunsuzluk tarafında yaşar
// (`nonconformityBes5Schema`) — ölü şema bırakmak, bir gün "bu uç neden
// çalışmıyor" sorusunu doğururdu.
/** Miktar birimi (çevre/proses sayı alanları — O7). */
exports.miktarBirimiSchema = zod_1.z.enum(['kg', 'lt', 'm3']);
/** F3B·S3 — sınıf yazımı (O1 ÇOKLU; "Diğer" serbest metin zorunluluğu
 *  serviste — cevap sözlük satırında, CHECK olamaz). */
exports.incidentSiniflarSchema = zod_1.z.object({
    siniflar: zod_1.z.array(zod_1.z.object({ sinifRefId: zod_1.z.uuid(), serbestMetin: zod_1.z.string().nullish() })),
});
/** F3B·S3 — mekanizma + sınıfa özel alanlar (undefined = dokunma, null =
 *  temizle; ayrım servise aynen taşınır). */
exports.incidentAlanlarSchema = zod_1.z.object({
    mekanizmaRefId: zod_1.z.uuid().nullish(),
    mekanizmaDigerMetin: zod_1.z.string().nullish(),
    yayilimSiniriRefId: zod_1.z.uuid().nullish(),
    salinanMiktar: zod_1.z.number().min(0).nullish(),
    salinanBirim: exports.miktarBirimiSchema.nullish(),
    resmiBildirimeTabi: zod_1.z.boolean().nullish(),
    kayipMiktari: zod_1.z.number().min(0).nullish(),
    kayipBirimi: exports.miktarBirimiSchema.nullish(),
    maddeTehlikeSinifiRefId: zod_1.z.uuid().nullish(),
    maddeSinifiDigerMetin: zod_1.z.string().nullish(),
    ikincilSonuc: zod_1.z.boolean().nullish(),
});
/** Seviye kademesi güncelleme (ad müşterinin — O6; silme yok, gizleme var). */
exports.severityLevelUpdateSchema = zod_1.z.object({
    ad: zod_1.z.string().min(1).optional(),
    gizli: zod_1.z.boolean().optional(),
});
/** Bir sınıfın türetme satırları (eşleme XOR eşik — satır kuralı serviste +
 *  DB CHECK). */
exports.severityRulesUpdateSchema = zod_1.z.object({
    satirlar: zod_1.z.array(zod_1.z.object({
        girdiSira: zod_1.z.number().int().min(0).max(5).nullish(),
        esikAlt: zod_1.z.number().min(0).nullish(),
        maddeSinifiRefId: zod_1.z.uuid().nullish(),
        seviyeId: zod_1.z.uuid(),
    })),
});
/** U9 — work_hours upsert gövdesi (elle + import AYNI kapı; düzeltme =
 *  üstüne yazma). Temsilcide `contractorId` YOK SAYILIR — oturumdan türetilir. */
exports.workHoursUpsertSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid(),
    yil: zod_1.z.number().int().min(2000).max(2100),
    ay: zod_1.z.number().int().min(1).max(12),
    saat: zod_1.z.number().min(0),
    contractorId: zod_1.z.uuid().nullish(),
});
/**
 * DÜĞME GÖRÜNÜRLÜĞÜ SUNUCUDAN (PTW `yetkiler` deseni): her alan tenant
 * listesi çözümlemesi + bahçe + durum birleşimidir; ekran ikinci kural
 * yazmaz — görünmeyen düğmenin ucu da aynı kapıdan reddeder.
 */
exports.incidentYetkilerSchema = zod_1.z.object({
    /** `olay_inceleme` çözümlemesi + bahçe (inceleme·red·akış·liste yazmaları). */
    inceleyebilir: zod_1.z.boolean(),
    /** inceleyebilir ∧ açık kayıt (`olayAcikMi`) ∧ KİMLİKLİ kayıt (U2 + K8). */
    turDuzeltebilir: zod_1.z.boolean(),
    /** Aksiyon açma kapısı (U11 — uzman + teknisyen aynı anahtarda; D1: yönetici
     *  şapkalar da) + bahçe. ⚠️ Kapalı olayda da AÇIK (K6 — yeni DÖF kilidi
     *  kaldırır); yalnız reddedilmiş olayda kapanır. */
    dofAcabilir: zod_1.z.boolean(),
    /** Araştırmaya yükseltme (F4·B4) — yetki = İNCELEME yetkisi (yeni eksen
     *  AÇILMADI) ∧ değerlendirme akışı ∧ investigating ∧ açık. Tek yönlü. */
    yukseltebilir: zod_1.z.boolean(),
    /** Kaza dosyası eki yükleme/silme — `olay_inceleme` çözümlemesi + bahçe
     *  (R13 — F3B·S5; durum kapısı YOK, ek kapanıştan sonra da yüklenebilir). */
    ekYonetebilir: zod_1.z.boolean(),
    /** Sebep ağacı doldurulabilir mi — inceleyebilir ∧ `sebepYazilabilirMi`
     *  (F4·B2 · §2.40): yöntem seçimi · düğüm ekleme/düzenleme/silme HEPSİ
     *  bu tek bayrağa bakar. Sunucudaki kapının İKİZİDİR, ekranda ikinci kural
     *  türetilmez — ayrışırsa bölüm yine "açık görünüp reddeden" hâle döner. */
    sebepYazabilir: zod_1.z.boolean(),
    /** Araştırma kayıtları (ortam · kronoloji · ekip · bağlı listeler)
     *  yazılabilir mi — inceleyebilir ∧ `olayAcikMi` (F4·B2·2 · §2.40): sunucu
     *  kapısının (`assertIncidentMutable`) İKİZİ; ekran ikinci kural yazmaz. */
    arastirmaKaydiYazabilir: zod_1.z.boolean(),
    /** P13 — `olay_inceleme` kapısı (tenant listesi → bahçe) + sebep; kanıt ekleri. */
    incelemeKapisi: kapi_durumu_1.kapiDurumuSchema,
    /**
     * P13 · B1c — araştırma bölümlerinin TEK kaynağı: inceleme kapısı ∧ içerik
     * kilidi (sebep = `IncidentKilitliError`in kendi cümlesi). ⚠️ Ekran beş
     * bölümün üçünde kapanış hâlini kendisi türetiyordu — artık yalnız bunu okur.
     */
    arastirmaKapisi: kapi_durumu_1.kapiDurumuSchema,
    /** P13 — DÖF açma = `POST actions` adımları + reddedilmemiş olay + sebep. */
    dofKapisi: kapi_durumu_1.kapiDurumuSchema,
    /**
     * KAYIP GÜN KAPISI (08.10.2026 — KG-3): açık olayda = `arastirmaKapisi`
     * (satır tam düzenlenir); kapanmış olayda = inceleme kapısı ∧ reddedilmemiş
     * ∧ işyeri arşivli değil (`requireWritableWorkplace` — arşiv adımı). Ekran
     * yalnız kayıp gün alanını bu kapıdan, basamak seçimini `arastirmaKapisi`nden
     * açar; sunucu `updateIncidentAffectedPerson` aynı kuralları koşar.
     */
    kayipGunKapisi: kapi_durumu_1.kapiDurumuSchema,
});
exports.incidentSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    takipNo: zod_1.z.string().min(1),
    durum: exports.incidentDurumSchema,
    akis: exports.incidentAkisSchema,
    olayTuruAd: zod_1.z.string().nullable(),
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string().min(1),
    locationAd: zod_1.z.string().nullable(),
    olayTarihi: zod_1.z.iso.datetime(),
    /** U3 — kayıttan türetilir (bildiren NULL); kolon değil. */
    anonim: zod_1.z.boolean(),
    /** Anonim kayıtta HER ZAMAN null — kimlik zaten kayıtta yok (R5). */
    bildirenAd: zod_1.z.string().nullable(),
    /** TÜRETİLMİŞ İŞARET (17.08.2026) — listede süzgeç, raporda sayaç. */
    majorArastirma: zod_1.z.boolean(),
    /** "Dosya eksik" TÜRETİLMİŞ İŞARET (R13 — F3B·S5): kaza + kapanmamış +
     *  canlı SGK eki yok (`kazaDosyasiEksikMi` tek yüklemi). */
    dosyaEksik: zod_1.z.boolean(),
    gerceklesenSiddetSira: zod_1.z.number().int().nullable(),
    potansiyelSiddetSira: zod_1.z.number().int().nullable(),
    puan5x5: zod_1.z.number().int().nullable(),
    /** DÖF SAYACI (✏️ T2·0 — 7-j.5): olayın durum göstergesidir; liste
     *  satırı + künye aynı çiftten çizilir, ekran saymaz. İptal DÖF (2½)
     *  toplama GİRMEZ. */
    toplamDofSayisi: zod_1.z.number().int(),
    acikDofSayisi: zod_1.z.number().int(),
    /** TÜRETİLMİŞ KAPANIŞ (7-j.3 — `olayKapaliMi`; kolon YOK). */
    kapali: zod_1.z.boolean(),
    /** Kapanış tarihi = son DÖF'ün kapanışı (MAX `action.kapanis_at`); açıkken null. */
    kapanisAt: zod_1.z.iso.datetime().nullable(),
    createdAt: zod_1.z.iso.datetime(),
});
exports.incidentDetailSchema = zod_1.z.object({
    ...exports.incidentSummarySchema.shape,
    anlati: zod_1.z.string(),
    /** Künye bağları (F4·B3 — A1): id'ler düzenleme yüzeyinin girdisi, adlar
     *  SUNUCUDA çözülür (ekran sözlük join'i yazmaz). */
    locationNodeId: zod_1.z.uuid().nullable(),
    equipmentId: zod_1.z.uuid().nullable(),
    equipmentAd: zod_1.z.string().nullable(),
    kayipGunSayisi: zod_1.z.number().int().nullable(),
    hasarTutari: zod_1.z.number().nullable(),
    olasilik5: zod_1.z.number().int().nullable(),
    siddet5: zod_1.z.number().int().nullable(),
    redGerekceAd: zod_1.z.string().nullable(),
    redGerekceMetin: zod_1.z.string().nullable(),
    mukerrerHedefTakipNo: zod_1.z.string().nullable(),
    /** Madde 309-b — TÜRETİLMİŞ İŞARET (R13 deseni): kayıp günlü basamakta
     *  (3–4) `kayip_gun` boş etkilenen sayısı; ölümlü NULL sayılmaz; kapanışı
     *  engellemez, kapalı kayıtta da görünür. Kolon YOK (`kayipGunEksikMi`). */
    kayipGunEksikVaka: zod_1.z.number().int(),
    etkilenenler: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        taraf: exports.incidentTarafSchema,
        adSoyad: zod_1.z.string().nullable(),
        siddetBasamagi: zod_1.z.number().int(),
        kayipGun: zod_1.z.number().int().nullable(),
        tedaviNotu: zod_1.z.string().nullable(),
        /** Yaralanma satırları (F4·B3 — A2): ÇOKLU; adlar sunucuda çözülür.
         *  ⚠️ Rapora ÇIKAR — tedavi notu çıkmaz (sağlık sınırı aynen). */
        yaralanmalar: zod_1.z.array(zod_1.z.object({
            id: zod_1.z.uuid(),
            yaralanmaTuruAd: zod_1.z.string(),
            vucutBolgesiAd: zod_1.z.string(),
            serbestMetin: zod_1.z.string().nullable(),
        })),
    })),
    hasarlar: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), kalem: zod_1.z.string(), tutar: zod_1.z.number().nullable() })),
    taniklar: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), adSoyad: zod_1.z.string().nullable(), ifade: zod_1.z.string() })),
    sebepler: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        /** Sözlük kalemi referansı — NULL = serbest metin düğümü (5 Neden'in
         *  ara adımları, balık kılçığının başlıkları). Yüzeyler bu alandan
         *  "işaretlenebilir mi" sorusunu okur; ada bakmak, aynı adı taşıyan
         *  serbest bir düğümü kalem sanmaya açık olurdu. */
        sebepRefId: zod_1.z.uuid().nullable(),
        sebepAd: zod_1.z.string().nullable(),
        grupAd: zod_1.z.string().nullable(),
        katman: zod_1.z.number().int().nullable(),
        kademe: zod_1.z.number().int().nullable(),
        ustSebepId: zod_1.z.uuid().nullable(),
        metin: zod_1.z.string().nullable(),
        kokSebepMi: zod_1.z.boolean(),
        serbestMetin: zod_1.z.string().nullable(),
        /** Bu sebebe bağlı DÖF sayaçları (F4·B4 — "DÖF sebeplere açılır").
         *  Satır eylemi + görünür durum bu ikiliden çizilir; ekran saymaz. */
        dofToplam: zod_1.z.number().int(),
        dofAcik: zod_1.z.number().int(),
    })),
    arastirmaYontemi: exports.incidentArastirmaYontemiDegeri.nullable(),
    /** Ortam bilgileri (F4·B2·2 — madde 146; hiçbiri zorunlu değil, O6).
     *  Adlar sunucuda çözülür (ekran sözlük join'i yazmaz). */
    ortam: zod_1.z.object({
        olaySaati: zod_1.z.string().nullable(),
        havaDurumu: zod_1.z.string().nullable(),
        aydinlatmaRefId: zod_1.z.uuid().nullable(),
        aydinlatmaAd: zod_1.z.string().nullable(),
        zeminRefId: zod_1.z.uuid().nullable(),
        zeminAd: zod_1.z.string().nullable(),
        vardiya: zod_1.z.string().nullable(),
    }),
    /** Kronoloji (A2 — tek taşıyıcı); sıra servis atar, liste sıradan dizilir. */
    kronoloji: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        sira: zod_1.z.number().int(),
        zaman: zod_1.z.iso.datetime().nullable(),
        metin: zod_1.z.string(),
    })),
    /** Araştırma ekibi — kişi referanslı; ÜYELİK YETKİ VERMEZ (R6 emsali). */
    arastirmacilar: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        personId: zod_1.z.uuid(),
        adSoyad: zod_1.z.string(),
        rol: exports.incidentInvestigatorRolSchema,
    })),
    gecisler: zod_1.z.array(zod_1.z.object({
        islem: zod_1.z.string(),
        eskiDurum: zod_1.z.string(),
        yeniDurum: zod_1.z.string(),
        yapanAd: zod_1.z.string().nullable(),
        sapka: zod_1.z.string().nullable(),
        createdAt: zod_1.z.iso.datetime(),
    })),
    /**
     * ETKİLENEN SATIRI DEĞİŞİKLİK GEÇMİŞİ (madde 310 — KG-3 ✏️;
     * `incident_affected_person_change_log`, değişmez): açık ve kapanmış olayda
     * basamak · kayıp gün · taraf. `gecisler` DURUM geçişleridir; bu liste ALAN
     * değişikliğidir. Yeniden eskiye sıralı; değer TEXT (taraf token — etiket
     * ekranda), boşsa link çizilmez.
     */
    degisiklikGecmisi: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        etkilenenAdSoyad: zod_1.z.string().nullable(),
        alan: zod_1.z.enum(exports.IZLENEN_ETKILENEN_ALANLARI),
        eskiDeger: zod_1.z.string().nullable(),
        yeniDeger: zod_1.z.string().nullable(),
        yapanAd: zod_1.z.string().nullable(),
        sapka: zod_1.z.string().nullable(),
        createdAt: zod_1.z.iso.datetime(),
    })),
    /** K1 — KÖK SEBEP İŞARETLENMEMİŞ (türetilmiş KALICI band; kapalı olayda
     *  da görünür): araştırma akışı ∧ ağaçta `kokSebepMi` düğüm yok. Kapı
     *  DEĞİL — DÖF açma ve kapanış türetmesi bundan bağımsız. */
    kokSebepIsaretsiz: zod_1.z.boolean(),
    /** K10 — O11 katman uyarısı türetilmiş KALICI band: işaretler YALNIZ
     *  1. katmanda (doğrudan sebepler) — neden zinciri sürüyor olabilir. */
    kokSebepYalnizDogrudan: zod_1.z.boolean(),
    siniflar: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        sinifRefId: zod_1.z.uuid(),
        ad: zod_1.z.string(),
        serbestMetin: zod_1.z.string().nullable(),
    })),
    mekanizmaRefId: zod_1.z.uuid().nullable(),
    mekanizmaAd: zod_1.z.string().nullable(),
    mekanizmaDigerMetin: zod_1.z.string().nullable(),
    sinifAlanlari: zod_1.z.object({
        yayilimSiniriRefId: zod_1.z.uuid().nullable(),
        salinanMiktar: zod_1.z.number().nullable(),
        salinanBirim: exports.miktarBirimiSchema.nullable(),
        resmiBildirimeTabi: zod_1.z.boolean().nullable(),
        kayipMiktari: zod_1.z.number().nullable(),
        kayipBirimi: exports.miktarBirimiSchema.nullable(),
        maddeTehlikeSinifiRefId: zod_1.z.uuid().nullable(),
        maddeSinifiDigerMetin: zod_1.z.string().nullable(),
        ikincilSonuc: zod_1.z.boolean().nullable(),
    }),
    /** Araştırmaya yükseltme ÖNERİSİ (F4·B4) — türetilmiş gösterim işareti
     *  (majör rozet ailesi): değerlendirme akışı ∧ investigating ∧ açık ∧
     *  `arastirmayaYukseltOnerisiMi`. Karar uzmanda — otomatik geçiş yok. */
    yukseltmeOnerisi: zod_1.z.boolean(),
    /** TÜRETİLEN seviye — değerlendirme akışında ve eşlemesiz sınıfta null. */
    seviye: zod_1.z.object({ sira: zod_1.z.number().int(), ad: zod_1.z.string() }).nullable(),
    /** D8 uyarıları (türetilmiş alan — engellemez). */
    seviyeUyarilari: zod_1.z.array(zod_1.z.string()),
    yetkiler: exports.incidentYetkilerSchema,
});
/** Tür düzeltme yanıtı (K8): detay + ENGELLEMEYEN uyarılar (aynı-akış
 *  değişiminde *"içerik korunur, uyumu kontrol edin"*). */
exports.incidentOlayTuruUpdateResponseSchema = zod_1.z.object({
    ...exports.incidentDetailSchema.shape,
    uyarilar: zod_1.z.array(zod_1.z.string()),
});
exports.incidentOptionsSchema = zod_1.z.object({
    workplaces: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string(), companyAd: zod_1.z.string() })),
    // ✏️ madde 64: `anonimSecilebilir` işareti DÜŞTÜ — Kapı 1'den anonim
    // gönderim kalktı; U1 tür kısıtı artık yalnız public yüzeyde işler.
    olayTurleri: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        ad: zod_1.z.string(),
        kutuphaneRef: zod_1.z.string().nullable(),
        /**
         * U8 (Tur 2½a) — bu tür UYGUNSUZLUK kabına mı düşer (tehlikeli
         * durum/davranış)? İşaret SUNUCUDAN: ekran kütüphane ref'i TANIMAZ ve
         * yönlendirmeyi ikinci kez türetmez (§2.40'ın tek-yüklem kolu).
         */
        uygunsuzlukMu: zod_1.z.boolean(),
    })),
    redGerekceleri: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        ad: zod_1.z.string(),
        kutuphaneRef: zod_1.z.string().nullable(),
        /** Mükerrer kalemi hedef kayıt referansı İSTER (R7) — işaret sunucudan. */
        hedefIster: zod_1.z.boolean(),
    })),
    kokSebepler: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        ad: zod_1.z.string(),
        grupAd: zod_1.z.string().nullable(),
        katman: zod_1.z.number().int().nullable(),
        grupSira: zod_1.z.number().int().nullable(),
        grupKod: zod_1.z.string().nullable(),
        saglikSiniri: zod_1.z.boolean(),
        digerMi: zod_1.z.boolean(),
    })),
    /** F3B·S4 — "Diğer" kuyruğundan kök sebep kalemi eklerken grup seçimi
     *  (T1); ref = grup sözlüğünün kutuphaneRef'i. */
    kokSebepGruplari: zod_1.z.array(zod_1.z.object({ ref: zod_1.z.string(), ad: zod_1.z.string() })),
    personeller: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), adSoyad: zod_1.z.string() })),
    contractors: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string() })),
    /** F3B·S3 — madde 58 kapanışıyla dolan sözlükler; "Diğer" işareti ve
     *  türetme girdisi SUNUCUDAN (ekran kütüphane ref'i tanımaz). */
    olaySiniflari: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        ad: zod_1.z.string(),
        digerMi: zod_1.z.boolean(),
        turetmeGirdisi: exports.olayTuretmeGirdisiSchema.nullable(),
    })),
    mekanizmalar: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string(), digerMi: zod_1.z.boolean() })),
    yayilimSiniflari: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string(), sira: zod_1.z.number().int().nullable() })),
    maddeSiniflari: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string(), digerMi: zod_1.z.boolean() })),
    /** F4·B2·2 — ortam sözlükleri (madde 146): aydınlatma + zemin. */
    aydinlatmalar: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string() })),
    zeminler: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string() })),
    /** F4·B3 — yaralanma sözlükleri (A2); "Diğer" işareti SUNUCUDAN. */
    yaralanmaTurleri: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string(), digerMi: zod_1.z.boolean() })),
    vucutBolgeleri: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string(), digerMi: zod_1.z.boolean() })),
    /** F4·B3 — künye bağlarının havuzları (A1): bahçedeki işyerlerinin
     *  lokasyon dalları ve AKTİF ekipmanları; ekran işyerine göre süzer. */
    lokasyonlar: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string(), workplaceId: zod_1.z.uuid() })),
    ekipmanlar: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string(), workplaceId: zod_1.z.uuid() })),
    /** U4 anahtarı — ✏️ madde 64: artık yalnız QR yüzeyini açar/kapar; ekran
     *  QR panelinde "kanal kapalı" bilgisini bundan gösterir. */
    anonimBildirimAcik: zod_1.z.boolean(),
    /** `olay_inceleme` üyeliği — tür-boş (KAZA) kaydı açma seçeneği (O10). */
    kazaAcabilir: zod_1.z.boolean(),
    /** `olay_inceleme` üyeliği — anonim bildirim QR'ı üretme/indirme (madde
     *  64 akşam kararı: saha operasyonu kimdeyse QR ondadır) + "Diğer"
     *  kuyruğu (T3). */
    qrUretebilir: zod_1.z.boolean(),
    /** `calisma_saati_giris` üyeliği (U9). */
    calismaSaatiGirebilir: zod_1.z.boolean(),
});
/** Seviye ölçeği yapılandırma yanıtı (F3B·S3 — GET incident-severity/config). */
exports.incidentSeverityConfigSchema = zod_1.z.object({
    seviyeler: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        sira: zod_1.z.number().int(),
        ad: zod_1.z.string(),
        gizli: zod_1.z.boolean(),
        kullanimda: zod_1.z.boolean(),
    })),
    kurallar: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        olaySinifiRefId: zod_1.z.uuid(),
        girdiSira: zod_1.z.number().int().nullable(),
        esikAlt: zod_1.z.number().nullable(),
        maddeSinifiRefId: zod_1.z.uuid().nullable(),
        seviyeId: zod_1.z.uuid(),
    })),
    siniflar: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string(), girdi: exports.olayTuretmeGirdisiSchema.nullable() })),
    maddeSiniflari: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string() })),
});
// ─────────────────────────────────────────────────────────────────────────────
// F3B·S4 — KAPI 2: anonim bildirim TEK KAPI (✅ madde 64, 17.08.2026 —
// Kapsam v0.44 §16.8/14-b). QR/link → oturumsuz public yüzey; token tenant +
// lokasyon taşır (HEDEFLEME aracıdır, "güvenlik" değil — kapı herkese
// açıktır, süzgeç inceleme/red katmanında). İşyeri/lokasyon TOKENDAN gelir,
// gövdeden kabul edilmez.
// ─────────────────────────────────────────────────────────────────────────────
/** QR üretme (oturumlu uç — yetki `olay_inceleme` listesi + bahçe). */
exports.incidentQrUretSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid(),
    locationNodeId: zod_1.z.uuid().nullish(),
});
exports.incidentQrSonucSchema = zod_1.z.object({
    token: zod_1.z.string().min(1),
    /** Public yüzeyin tam adresi (`/bildirim?t=<token>`) — QR bu adresi taşır. */
    link: zod_1.z.string().min(1),
    workplaceAd: zod_1.z.string(),
    locationAd: zod_1.z.string().nullable(),
});
/**
 * Public form açılışı — token sorgu parametresiyle. Yanıt DAR (D2): işyeri/
 * lokasyon adı (QR zaten oraya asılı) + YALNIZ U1 türleri. Kanal kapalıysa
 * uç 404 sınıfı "kapalı" cevabı verir — bu şema hiç dönmez.
 */
exports.publicBildirimOptionsSchema = zod_1.z.object({
    workplaceAd: zod_1.z.string(),
    locationAd: zod_1.z.string().nullable(),
    /** YALNIZ tehlikeli durum/davranış (U1) — sunucu süzer, ekran taşıyıcı. */
    turler: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string() })),
});
/** Public kayıt gövdesi — işyeri/lokasyon YOK (tokendan gelir). */
exports.publicBildirimCreateSchema = zod_1.z.object({
    token: zod_1.z.string().min(1),
    olayTuruRefId: zod_1.z.uuid(),
    olayTarihi: zod_1.z.iso.datetime(),
    anlati: zod_1.z.string().min(1),
});
exports.publicBildirimSonucSchema = zod_1.z.object({ takipNo: zod_1.z.string().min(1) });
/**
 * Public takip sorgusu yanıtı — kayıt detayının TAMAMI DEĞİL: yalnız durum +
 * tarih (içerik sızdırılmaz — D2). `strict`: yarın eklenen bir alan bu
 * yüzeye SESSİZCE sızamaz (PTW QR özetinin envanter deseni).
 */
exports.publicTakipDurumSchema = zod_1.z
    .object({
    takipNo: zod_1.z.string().min(1),
    durum: exports.incidentDurumSchema,
    /** TÜRETİLMİŞ kapanış (K11) — ekranda nötr *Sonuçlandı*; akış EKLENMEZ (D2). */
    kapali: zod_1.z.boolean(),
    olayTarihi: zod_1.z.iso.datetime(),
})
    .strict();
/**
 * "Diğer" kuyruğu (T3 — F3B·S4; **F3B·S9'da SÖZLÜK BAKIM ekranına dönüştü**):
 * sözlük alanlarında "Diğer" seçilmiş kayıtların serbest metinleri; uzman
 * tekrar edenleri tenant nüshasına KALICI kalem yapar (mevcut lookup nüsha
 * ekleme mekanizması — yeni mekanizma yok).
 *
 * ✏️ **KAPSAM GENİŞLEDİ (✅ ürün sahibi 19.08.2026, FARK 1):** kuyruk artık
 * OLAY MODÜLÜNE AİT DEĞİLDİR — **sözlük bakım yüzeyidir** ve risk
 * sözlüklerinin "Diğer" metinlerini de taşır. Menüdeki yeri olay modülünün
 * altından çıkıp yapılandırma tarafına taşındı.
 *
 * **SATIRLAR YETKİYE GÖRE FİLTRELENİR** (`kaynak` ekseni): kullanıcı hangi
 * tenant liste anahtarında yetkiliyse o kaynaktan gelen satırları görür —
 * olay metinleri `olay_inceleme`, risk metinleri `risk_degerlendirme`.
 * İkisi de varsa hepsini görür; hiçbiri yoksa 403. Kalıcı kaleme
 * dönüştürmede kapı **HEDEF SÖZLÜĞE** göre seçilir (aynı eksen).
 */
exports.DIGER_KUYRUGU_LISTELERI = [
    'olay_sinifi',
    'mekanizma',
    'madde_tehlike_sinifi',
    'kok_sebep',
    'risk_tehlike',
    'risk_riski',
];
exports.digerKuyruguListeSchema = zod_1.z.enum(exports.DIGER_KUYRUGU_LISTELERI);
/** Satırın hangi MODÜLDEN geldiği — yetki filtresinin ve örnek bağlantısının
 *  ekseni (tek kaynak; ekran ikinci eşleme yazmaz). */
exports.DIGER_KUYRUGU_KAYNAKLARI = ['olay', 'risk'];
exports.digerKuyruguKaynakSchema = zod_1.z.enum(exports.DIGER_KUYRUGU_KAYNAKLARI);
/** Liste kodu → kaynak eşlemesi. Yeni bir "Diğer" taşıyan sözlük eklenirse
 *  BURAYA da eklenir; envanter testi eksik eşlemeyi kırmızıya çevirir. */
exports.DIGER_KUYRUGU_KAYNAGI = {
    olay_sinifi: 'olay',
    mekanizma: 'olay',
    madde_tehlike_sinifi: 'olay',
    kok_sebep: 'olay',
    risk_tehlike: 'risk',
    risk_riski: 'risk',
};
exports.digerKuyruguSatirSchema = zod_1.z.object({
    listeKodu: exports.digerKuyruguListeSchema,
    kaynak: exports.digerKuyruguKaynakSchema,
    /** Kalıcı kaleme dönüştürme kapısı (P13) — hedef sözlüğün tenant listesi.
     *  Kuyruğu OKUYAN herkes dönüştüremez (holding yön. · izleyici okur). */
    kalemKapisi: kapi_durumu_1.kapiDurumuSchema,
    metin: zod_1.z.string().min(1),
    /** Aynı metnin kaç kayıtta geçtiği (tekrar edenler kalem adayıdır — T3). */
    sayi: zod_1.z.number().int().min(1),
    /** Örnek kayıtlar — olay satırında olay, risk satırında risk maddesi.
     *  `takipNo` olayın izlenebilir numarası, riskte değerlendirme adıdır. */
    ornekler: zod_1.z.array(zod_1.z.object({ kayitId: zod_1.z.uuid(), etiket: zod_1.z.string() })),
});
/**
 * Kuyruktan kalıcı kalem ekleme. Sınıf kaleminde ana kaleme bağ ZORUNLU
 * (`turetme_girdisi` mirası — Park 2, mini belge turu 17.08.2026); kök
 * sebep kaleminde grup ZORUNLU (T1 — her kalem grup etiketi taşır).
 * Zorunlulukların kendisi SERVİSTE denetlenir (422) — şema ikisini de
 * opsiyonel taşır (hangi listede hangisinin gerektiği tek yerde kalsın).
 */
exports.digerKuyrukKalemSchema = zod_1.z.object({
    listeKodu: exports.digerKuyruguListeSchema,
    ad: zod_1.z.string().min(1),
    anaKalemId: zod_1.z.uuid().nullish(),
    grupRef: zod_1.z.string().min(1).nullish(),
});
exports.workHoursRowSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string(),
    donem: zod_1.z.iso.datetime(),
    saat: zod_1.z.number(),
    kaynak: exports.workHoursKaynakSchema,
    contractorId: zod_1.z.uuid().nullable(),
    contractorAd: zod_1.z.string().nullable(),
});
/** Kaza dosyası eki satırı (R13 — F3B·S5; actionAttachmentSchema + ekTipi). */
exports.incidentAttachmentSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    ekTipi: exports.incidentEkTipiSchema,
    /** Kanıt kategorisi (F4·B2·2) — tipten ayrı eksen; mevcut eklerde null. */
    kanitKategorisi: exports.incidentKanitKategorisiSchema.nullable(),
    dosyaAdi: zod_1.z.string().min(1),
    mimeType: zod_1.z.string().min(1),
    boyutBytes: zod_1.z.number().int().positive(),
    yukleyenAppUserId: zod_1.z.uuid(),
    yukleyenEtiket: zod_1.z.string().min(1),
    createdAt: zod_1.z.iso.datetime(),
});
/**
 * Çalışma saati İÇE AKTARMA sonucu (F3B·S5 — §16.8.1; person-import satır
 * sonucu deseni). KISMİ BAŞARI satır düzeyinde: `hata` satırı isteği
 * düşürmez; YETKİ istek düzeyindedir (bahçe dışı işyeri → 403, hiçbir
 * satır işlenmez). `yeni`/`guncellendi` upsertWorkHours'un kendi
 * sonucudur — aynı dosya ikinci kez = tüm satırlar `guncellendi`.
 */
exports.WORK_HOURS_IMPORT_SONUCLARI = ['yeni', 'guncellendi', 'hata'];
exports.workHoursImportSonucSchema = zod_1.z.enum(exports.WORK_HOURS_IMPORT_SONUCLARI);
exports.workHoursImportRowResultSchema = zod_1.z.object({
    satir: zod_1.z.number().int().positive(),
    sonuc: exports.workHoursImportSonucSchema,
    mesaj: zod_1.z.string().nullable(),
});
exports.workHoursImportReportSchema = zod_1.z.object({
    toplam: zod_1.z.number().int().min(0),
    yeni: zod_1.z.number().int().min(0),
    guncellenen: zod_1.z.number().int().min(0),
    hatali: zod_1.z.number().int().min(0),
    satirlar: zod_1.z.array(exports.workHoursImportRowResultSchema),
});
exports.incidentYetkilerContractIsInSync = true;
exports.incidentSummaryContractIsInSync = true;
exports.incidentDetailContractIsInSync = true;
exports.incidentOlayTuruUpdateResponseContractIsInSync = true;
exports.incidentOptionsContractIsInSync = true;
exports.workHoursRowContractIsInSync = true;
exports.incidentSeverityConfigContractIsInSync = true;
exports.incidentAttachmentContractIsInSync = true;
exports.workHoursImportReportContractIsInSync = true;
//# sourceMappingURL=incident.js.map